



export const EVENT_DATE = '2025-11-06';
export const NAV_HEIGHT = '86px';

export const REMA_LANDING_PAGE_URL = "/rema";
export const REMA_REGISTRATION_PAGE_ROUTE = "/register-rema";
export const REMA_REGISTRATION_PAGE_URL = `${REMA_REGISTRATION_PAGE_ROUTE}?event_id=0b41943ebe`;

export const REMA_SPONSORSHIP_PAGE_URL = 'https://tally.so/r/w8OdGx'







export const EVENT_EXPECTATION_DATA = [
  {
    id: 1,
    title: "Keynotes & Panels",
    description:
      "Gain insights from leading voices in real estate, technology, and government as they share strategies for building resilient, well-managed urban communities.",

  },
  {
    id: 2,
    title: "Exhibitions & Tech Showcase",
    description:
      "Explore innovative PropTech, energy, finance, and smart-living solutions that go beyond construction to drive operational excellence.",

  },
  {
    id: 3,
    title: "Networking & Partnerships",
    description:
      "Forge meaningful connections with developers, policymakers, and investors committed to shaping Africa’s next phase of urban transformation.",

  },
];

export const ATTENDEE_CATEGORIES = [
  {
    title: "Real Estate Developers & Investors",
    content:
      "Discover strategies and partnerships that unlock long-term value creation beyond construction.",
  },
  {
    title: "Facility & Property Managers",
    content:
      "Learn how to leverage technology and governance models to deliver smarter, more efficient communities.",
  },
  {
    title: "Policymakers & Urban Planners",
    content:
      "Gain insights into current regulatory frameworks that balance growth with sustainability and community resilience.",
  },
  {
    title: "Technology & PropTech Innovators",
    content:
      "Showcase solutions, connect with decision-makers, and scale impact across Africa’s urban landscape.",
  },
  {
    title: "Utility Providers & Infrastructure Companies",
    content:
      "Explore and showcase opportunities to integrate services into the next generation of African smart estates.",
  },
  {
    title: "Community Association Executives ",
    content:
      "Access practical tools and case studies to strengthen governance, security, resident satisfaction and engagement.",
  },
  {
    title: "Financial Institutions & Impact Investors",
    content:
      "Identify emerging opportunities to fund transformative real estate and PropTech ventures across the continent.",
  },
  {
    title: "Media & Press",
    content:
      "Gain first-hand access to industry insights, breaking trends, and direct engagement with leading voices in real estate and PropTech",
  },
  {
    title: "Estate Residents",
    content:
      "Explore innovations and best practices that improve daily living, community management, and the future of smart estates.",
  },
];

export const FOCUS_AREAS = [
  {
    index: "01",
    label: "Community Management & Governance",
  },
  {
    index: "02",
    label: "PropTech & Innovation",
  },
  {
    index: "03",
    label: "Policy, Regulation & Infrastructure",
  },
  {
    index: "04",
    label: "Sustainability & Value Creation",
  },
];

export const FOOTER_LINKS = [
  {
    name: "Register to Attend",
    href: REMA_REGISTRATION_PAGE_URL,
  },
  {
    name: "Become a Sponsor or Exhibitor",
    href: REMA_SPONSORSHIP_PAGE_URL,
  },
  {
    name: "Media Accreditation",
    href: 'https://tally.so/r/n0Nd00',
  },
];


export const EVENT_SCHEDULE = [
  {
    label: "Morning",
    value: [
      {
        slot: "08:00-09:15",
        activity: "Smart Estate Registration & Welcome",
      },
      {
        slot: "09:15-09:30",
        activity: "Orientation & Opening Demo",
      },
      {
        slot: "09:30-09:50",
        activity: "Keynote: Policy Frameworks for Sustainable Urban Communities",
      },
      {
        slot: "09:50-10:10",
        activity: "Keynote: Green Deal or Real Deal?",
      },
      {
        slot: "10:10-11:00",
        activity: "Panel: The Digital Future of African Communities",
      },
      {
        slot: "11:00-11:30",
        activity: "Experiential Tech Walkthrough",
      },
    ]
  },
  {
    label: 'Afternoon',
    value: [
      {
        slot: "11:30-12:10",
        activity: "Panel (Deep Dive Session 1): Cost Optimisation for Multi-Property Portfolios",
      },
      {
        slot: "12: 10-12: 30",
        activity: "Panel (Deep Dive Session 2): Energy Tariff Management",
      },
      {
        slot: "12:30-13:10",
        activity: "Panel (Deep Dive Session 3): Designing Governance Before Handover – Inclusive Urban Futures",
      },
      {
        slot: "13:10-13:50",
        activity: "Lunch & Marketplace Hour",
      },
      {
        slot: "13:50-15:00",
        activity: "Panel: Smart Security & Safety for African Buildings",
      },
      {
        slot: "15:00-15:50",
        activity: "Panel: Unlocking the Data Economy of Urban Living",
      },
    ]
  },
  {
    label: "Evening",
    value: [
      {
        slot: "15:50-16:40",
        activity: "Special Launch Segment: New Venco Products",
      },
      {
        slot: "16:40-17:00",
        activity: "Keynote: Beyond the Build - The Future of African Real Estate Ecosystems",
      }
    ]
  },
]
